import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  getKyPhatHanhListApi,
  sinhBoSoQrApi,
  getJobProgressApi,
  exportQrCsvApi,
} from 'helpers/fakebackend_helper';
import { toast } from 'react-toastify';
import { createScreenText } from 'helpers/screenText';
const st = createScreenText('sinh_bo_so_qr_messages');

interface FetchKyPhatHanhParams {
  pageIndex?: number;
  pageSize?: number;
  search?: string;
  trangThaiQR?: string;
}

const cleanParams = (params: any): any => {
  const cleaned: any = {};
  Object.keys(params).forEach((key) => {
    const value = params[key];
    if (value !== null && value !== undefined && value !== '') {
      cleaned[key] = value;
    }
  });
  return cleaned;
};

export const fetchKyPhatHanhList = createAsyncThunk(
  'SinhBoSoQr/fetchKyPhatHanhList',
  async (params: FetchKyPhatHanhParams = {}, { rejectWithValue }) => {
    try {
      const response = await getKyPhatHanhListApi(cleanParams(params));
      return response.data || response;
    } catch (error: any) {
      const message = error?.message || st('khong_the_tai_danh_sach_ky_text');
      toast.error(message);
      return rejectWithValue(message);
    }
  }
);

export const sinhBoSoQr = createAsyncThunk(
  'SinhBoSoQr/sinhBoSoQr',
  async (lotteryPeriodId: number, { rejectWithValue }) => {
    try {
      const response = await sinhBoSoQrApi(lotteryPeriodId);
      const jobData = response.data || response;
      localStorage.setItem(`lms_active_job_${lotteryPeriodId}`, jobData.jobId);
      toast.success(st('da_khoi_dong_qua_trinh_sinh_message'));
      return jobData;
    } catch (error: any) {
      const message = error?.message || st('khong_the_khoi_dong_job_sinh_text');
      toast.error(message);
      return rejectWithValue(message);
    }
  }
);

export const fetchJobProgress = createAsyncThunk(
  'SinhBoSoQr/fetchJobProgress',
  async (jobId: string, { rejectWithValue }) => {
    try {
      const response = await getJobProgressApi(jobId);
      return response.data || response;
    } catch (error: any) {
      const message = error?.message || st('khong_the_cap_nhat_tien_trinh_text');
      return rejectWithValue(message);
    }
  }
);

export const exportQrCsv = createAsyncThunk(
  'SinhBoSoQr/exportCsv',
  async (lotteryPeriodId: number, { rejectWithValue }) => {
    try {
      const response = await exportQrCsvApi(lotteryPeriodId);
      const blobContent = (response as any)?.data || response;
      const downloadUrl = window.URL.createObjectURL(new Blob([blobContent]));
      const link = document.createElement('a');
      link.href = downloadUrl;
      link.setAttribute('download', `qr_codes_${lotteryPeriodId}_${Date.now()}.csv`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(downloadUrl);
      toast.success(st('tai_xuong_file_csv_thanh_cong_message'));
      return true;
    } catch (error: any) {
      const message = error?.message || st('khong_the_tai_xuong_file_csv_text');
      toast.error(message);
      return rejectWithValue(message);
    }
  }
);
